import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogerrorComponent } from './catalogerror/catalogerror.component';
import { LoginErrorComponent } from './login-error/loginerror.component';
import { ReportingRoleNotificationComponent } from './reporting-role-notification/reporting-role-notification.component';

const routes: Routes = [
  { path: 'error', component: LoginErrorComponent },
  { path: 'role-notification', component: ReportingRoleNotificationComponent },
  { path: 'catalog-error', component: CatalogerrorComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule { }

export const routedComponents = [LoginErrorComponent, ReportingRoleNotificationComponent, CatalogerrorComponent];
